export const CONSTRUCTION_EVENT_TYPES = [
  {
    id: 0,
    name: 'all',
    display_text: 'TOUS',
    tag_text: 'TOUS',
  },
  {
    id: 1,
    name: 'chainsaw',
    display_text: 'Utilisation de la tronçonneuse thermique',
    tag_text: 'TRONÇONNEUSE',
    threshold: 60,
    criteria: [
      {name: 'fuel_confidence', display_text: 'Tronçonneuse thermique visible', weight: 0.7},
      {name: 'electric_confidence', display_text: 'Tronçonneuse électrique visible', weight: 0.3},
    ]
  },
  {
    id: 2,
    name: 'collision',
    display_text: 'Risque de collision avec godet',
    tag_text: 'COLLISION GODET',
    threshold: 70,
    criteria: [
      {name: 'score_mvt_inter', display_text: 'Vitesse de déplacement des éléments', weight: 0.3},
      {name: 'score_bucket_in_sight', display_text: 'Non visibilité du godet', weight: 0.3},
      {name: 'depth_score', display_text: 'Proximité humain/godet', weight: 0.4},
    ]
  },
  {
    id: 3,
    name: 'deadman',
    display_text: 'Détection d\'homme inerte',
    tag_text: 'HOMME INERTE',
    threshold: 70,
    criteria: [
      {name: 'dy0_dt_score', display_text: 'Vitesse de chute', weight: 0.7},
      {name: 'head_knees_delta_score', display_text: 'Posture anormale', weight: 0.4},
      {name: 'legs_angle_score', display_text: 'Position des jambes', weight: 0.7},
      {name: 'rf_score', display_text: 'Analyse du squelette', weight: 0.3},
    ]
  },
  {
    id: 4,
    name: 'reversing',
    display_text: 'Risque de collision avec engin',
    tag_text: 'COLLISION ENGIN',
    threshold: 80,
    criteria: [
      {name: 'mvt_score', display_text: 'Vitesse de déplacement', weight: 0.34},
      {name: 'proximity_score', display_text: 'Proximité', weight: 0.66},
    ]
  },
  {
    id: 5,
    name: 'intrusion',
    display_text: 'Intrusion dans la zone de chantier',
    tag_text: 'INTRUSION',
    threshold: -100,
    criteria: []
  }
]